(function () {
  var frame = 0;
  var attempts = 0;
  var retryTimer;

  function syncRail() {
    var app = document.querySelector('.yq-app');
    var logo = document.querySelector('.modo-nav__logo');
    var orderButton = document.querySelector('.buy-widget__btn');

    if (!app || !logo || !orderButton) return false;

    var logoRect = logo.getBoundingClientRect();
    var orderRect = orderButton.getBoundingClientRect();
    var left = Math.max(20, logoRect.left);
    var right = Math.max(20, document.documentElement.clientWidth - orderRect.right);

    app.style.setProperty('--modo-track-rail-left', left + 'px');
    app.style.setProperty('--modo-track-rail-right', right + 'px');
    return true;
  }

  function scheduleSync() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(syncRail);
  }

  function retrySync() {
    attempts += 1;
    if (!syncRail() && attempts < 40) {
      retryTimer = window.setTimeout(retrySync, 100);
    }
  }

  function bindStaticForms() {
    document.querySelectorAll('[data-modo-static-track-form]').forEach(function (form) {
      if (form.dataset.modoStaticBound === 'true') return;

      form.dataset.modoStaticBound = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
      });
    });
  }

  function start() {
    window.clearTimeout(retryTimer);
    attempts = 0;
    bindStaticForms();
    retrySync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('load', start, { once: true });
  window.addEventListener('resize', scheduleSync, { passive: true });
  document.addEventListener('shopify:section:load', start);
})();
